<template>
    <div>
        <div class="title">
            <h4 class="mb-0">Invoices</h4>
        </div>
        <div class="d-flex justify-content-end mb-3">
            <button
                v-if="selectedInvoices.length"
                type="button"
                class="btn mr-2"
                style="
                    background-color: #180f29;
                    color: white;
                    position: relative;
                "
                @click="downloadViewAllInvoices(true)"
            >
                <div
                    v-if="isAllViewLoading"
                    style="position: absolute; width: calc(100% - 24px)"
                >
                    <spinner />
                </div>
                <span
                    :style="{
                        color: isAllViewLoading ? 'transparent' : 'white'
                    }"
                    >View
                    {{
                        isAllInvoiceSelected
                            ? "all"
                            : `selected (${selectedInvoices.length})`
                    }}</span
                >
            </button>
            <button
                v-if="selectedInvoices.length"
                type="button"
                class="btn mr-2"
                style="
                    background-color: #180f29;
                    color: white;
                    position: relative;
                "
                @click="downloadViewAllInvoices(false)"
            >
                <div
                    v-if="isAllDownloadLoading"
                    style="position: absolute; width: calc(100% - 24px)"
                >
                    <spinner />
                </div>
                <span
                    :style="{
                        color: isAllDownloadLoading ? 'transparent' : 'white'
                    }"
                    >Download
                    {{
                        isAllInvoiceSelected
                            ? "all"
                            : `selected (${selectedInvoices.length})`
                    }}</span
                >
            </button>
            <button
                type="button"
                class="btn"
                style="background-color: #e1e1e1"
                @click="openFilterDate"
            >
                <span>Filter Date</span>
            </button>
        </div>
        <div>
            <LoaderList v-if="isLoading" class="w-100" />
            <div v-else class="table-responsive">
                <table class="table list">
                    <thead>
                        <tr>
                            <th>
                                <div class="d-flex align-items-center">
                                    <b-form-checkbox
                                        name="checkall"
                                        v-model="selectAll"
                                        @change="toggleAll"
                                        plain
                                    />
                                    <span>Date:</span>
                                </div>
                            </th>
                            <th>Invoice Number:</th>
                            <th>Total Amount:</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="invoices && invoices.length">
                        <template v-for="(invoice, index) in invoices">
                            <tr :key="'row-' + index">
                                <td>
                                    <div class="d-flex align-items-center">
                                        <b-form-checkbox
                                            :name="invoice.invoiceNumber"
                                            v-model="invoice.selected"
                                            @change="toggleOne"
                                            plain
                                        />
                                        <span>{{
                                            getInvoiceDate(invoice)
                                        }}</span>
                                    </div>
                                </td>
                                <td>{{ invoice.invoiceNumber }}</td>
                                <td>${{ invoice.amount.toFixed(2) }}</td>
                                <td class="text-right small text-nowrap">
                                    <spinner v-if="invoice.isLoading"></spinner>
                                    <div v-else>
                                        <span
                                            style="cursor: pointer"
                                            @click="
                                                downloaViewInvoice(
                                                    invoice,
                                                    true
                                                )
                                            "
                                            >View</span
                                        >
                                        <span> | </span>
                                        <span
                                            style="cursor: pointer"
                                            @click="
                                                downloaViewInvoice(
                                                    invoice,
                                                    false
                                                )
                                            "
                                            >Download</span
                                        >
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td :colspan="9">
                                <i>No records available</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <FilterDateRangeModal
            ref="filterDateRangeWindow"
            :selectedDate="selectedDate"
            @getInvoices="getInvoices"
        />
    </div>
</template>

<script>
import subscriptionService from "@/services/subscription";
import { forEach } from "lodash";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        FilterDateRangeModal: () =>
            import("@/components/setting-subscription/invoice-date-range.vue"),
        Spinner: () => import("@/components/elements/spinner.vue")
    },
    data() {
        return {
            selectAll: false,
            isLoading: true,
            isViewLoading: false,
            isDownloadLoading: false,
            isAllViewLoading: false,
            isAllDownloadLoading: false,
            invoices: [],
            selectedDate: {
                start: moment(),
                end: moment(),
                code: "5"
            }
        };
    },
    computed: {
        selectedInvoices() {
            return this.invoices.filter(invoice => invoice.selected);
        },
        isAllInvoiceSelected() {
            const selectedInvoices = this.invoices.filter(
                invoice => invoice.selected
            );
            return selectedInvoices.length === this.invoices.length;
        }
    },
    async created() {
        this.selectedDate.start = moment().tz(this._timeZone).startOf("year");
        this.selectedDate.end = moment().tz(this._timeZone).endOf("year");
        await this.getInvoices();
    },
    methods: {
        getInvoiceDate(invoice) {
            return this._setDateDisplay(invoice.invoiceDate);
        },
        async getInvoices(newSelectedDate) {
            this.isLoading = true;

            if (newSelectedDate) {
                this.selectedDate = newSelectedDate;
            }

            const response = await subscriptionService.getInvoices({
                from: this.selectedDate.start.format("YYYY-MM-DD"),
                to: this.selectedDate.end.format("YYYY-MM-DD")
            });

            if (response) {
                this.invoices = response.map(invoice => {
                    return {
                        ...invoice,
                        selected: false,
                        isLoading: false
                    };
                });
            }

            this.isLoading = false;
        },
        async downloaViewInvoice(invoice, isViewOnly = false) {
            if (this.isDownloadLoading || this.isViewLoading) return;

            if (isViewOnly) {
                this.isViewLoading = true;
            } else {
                this.isDownloadLoading = true;
            }

            invoice.isLoading = true;

            const response = await subscriptionService.getInvoicePdf(
                invoice.id
            );

            if (response && !this.checkPdfError(response)) {
                const blob = new Blob([response], { type: "application/pdf" });
                const url = URL.createObjectURL(blob);

                if (isViewOnly) {
                    window.open(url, "_blank");
                } else {
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = invoice.invoiceNumber + ".pdf";
                    document.body.appendChild(link);
                    link.click();
                }
            }

            invoice.isLoading = false;
            this.isDownloadLoading = false;
            this.isViewLoading = false;
        },
        async downloadViewAllInvoices(isViewOnly) {
            if (this.isAllDownloadLoading || this.isAllViewLoading) return;

            if (isViewOnly) {
                this.isAllViewLoading = true;
            } else {
                this.isAllDownloadLoading = true;
            }

            const downloadedInvoices = [];
            let hasError = false;

            for (const selectedInvoice of this.selectedInvoices) {
                const downloadedInvoice =
                    await subscriptionService.getInvoicePdf(selectedInvoice.id);

                if (downloadedInvoice) {
                    downloadedInvoices.push(downloadedInvoice);
                    if (this.checkPdfError(downloadedInvoice)) {
                        hasError = true;
                        break;
                    }
                }
            }

            if (!hasError) {
                downloadedInvoices.forEach((downloadedInvoice, index) => {
                    const blob = new Blob([downloadedInvoice], {
                        type: "application/pdf"
                    });

                    const url = URL.createObjectURL(blob);

                    if (isViewOnly) {
                        window.open(url, "_blank");
                    } else {
                        const link = document.createElement("a");
                        link.href = url;
                        link.download =
                            this.selectedInvoices[index].invoiceNumber + ".pdf";
                        document.body.appendChild(link);
                        link.click();
                    }
                });
            }

            this.isAllDownloadLoading = false;
            this.isAllViewLoading = false;
        },
        openFilterDate() {
            this.$refs.filterDateRangeWindow.open();
        },
        async toggleAll(checked) {
            forEach(this.invoices, function (invoice) {
                invoice.selected = checked;
            });
        },
        async toggleOne(selected) {
            if (!selected) {
                this.selectAll = false;
            } else if (
                selected &&
                this.selectedInvoices.length == this.invoices.length - 1
            ) {
                this.selectAll = true;
            }
        },
        checkPdfError(arrayBuffer) {
            const decoder = new TextDecoder("utf-8");
            const jsonString = decoder.decode(arrayBuffer);

            try {
                const responseInJson = JSON.parse(jsonString);

                if (
                    responseInJson &&
                    responseInJson.code &&
                    responseInJson.code &&
                    responseInJson.code !== 200 &&
                    responseInJson.message
                ) {
                    this._message(responseInJson.message, "danger");
                    return true;
                } else {
                    return false;
                }
            } catch (error) {
                return false;
            }
        }
    }
};
</script>

<style scoped></style>
